module.exports = __webpack_public_path__ + "img/camera.497a6b40.svg";